/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventvisibilityrequestdescription3Inputs */

const en_eventvisibilityrequestdescription3 = /** @type {(inputs: Eventvisibilityrequestdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone sees it, only people you accept get in.`)
};

const de_eventvisibilityrequestdescription3 = /** @type {(inputs: Eventvisibilityrequestdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle sehen sie, rein kommt nur, wen du annimmst.`)
};

/**
* | output |
* | --- |
* | "Everyone sees it, only people you accept get in." |
*
* @param {Eventvisibilityrequestdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventvisibilityrequestdescription3 = /** @type {((inputs?: Eventvisibilityrequestdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventvisibilityrequestdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventvisibilityrequestdescription3(inputs)
	return de_eventvisibilityrequestdescription3(inputs)
});
export { eventvisibilityrequestdescription3 as "eventVisibilityRequestDescription" }